import { FC } from 'react';
import { Skeleton } from 'ui/skeleton';
import { FlexWrapper } from 'modules/frequencyManagement/components/engagementMetrics/EngagementMetricsPopover.styles';

export const EngagementMetricsSkeletonId = `engagement-metrics-skeleton`;

export const EngagementMetricsSkeleton: FC = () => {
  return (
    <FlexWrapper data-test={EngagementMetricsSkeletonId}>
      <Skeleton isRound height={24} width={216} />
      <Skeleton isRound height={24} width={216} />
      <Skeleton isRound height={24} width={216} />
      <Skeleton isRound height={24} width={216} />
    </FlexWrapper>
  );
};
